import { Button } from 'antd';
import clsx from 'clsx';
import React from 'react';

import {
  Gap,
  Gutter,
  Icon,
  Flex,
  StatePill,
  Text,
  TimeWithTimeZone,
} from '@common/components';
import { DetailItemAttachmentType } from '@onboarding/graphql';

export const FilesCardItem = ({
  attachment,
  className,
  deleteLoading = false,
  onEdit,
  onDelete,
}: {
  attachment: DetailItemAttachmentType;
  className?: string;
  deleteLoading?: boolean;
  onEdit?: (attachmentId: string) => void;
  onDelete?: (attachmentId: string) => void;
}) => {
  return (
    <Gutter
      direction="vertical"
      className={clsx('wk-files-card-item', className)}
      internal
    >
      <Gutter direction="horizontal" size="md" internal>
        <Flex align="center" justify="space-between">
          <Gap vertical size="xs">
            <Gap size="md">
              <Text size="lg" color="elm" align="left">
                {attachment.file.filename}
              </Text>
              <a
                data-testid="download-link"
                href={attachment.file.downloadUrl || undefined}
              >
                <Icon icon="download" color="elm" />
              </a>
            </Gap>

            <Text size="sm" align="left">
              <Text size="sm" transform="capitalize">
                {attachment.status}
              </Text>{' '}
              on{' '}
              <TimeWithTimeZone
                date={attachment.file.createdAt}
                variant="long_format"
              />
            </Text>
          </Gap>
          <Gap>
            {attachment.expired && (
              <StatePill
                color="coral-hyperlight"
                icon={<Icon icon="triangleExclamation" color="coral" />}
              >
                Expired
              </StatePill>
            )}

            {attachment.canUpdate.value && onEdit && (
              <Button type="link" onClick={() => onEdit(attachment.id)}>
                <Icon icon="pen" color="elm" />
              </Button>
            )}

            {attachment.canDelete.value && onDelete && (
              <Button
                danger
                type="link"
                disabled={deleteLoading}
                onClick={() => onDelete(attachment.id)}
              >
                Delete
              </Button>
            )}
          </Gap>
        </Flex>
      </Gutter>
    </Gutter>
  );
};
